import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const scaleUp = (main, el) => {
    gsap.matchMedia().add(
        "(min-width: 900px)", () => {
            const tl = gsap.timeline();
            const select = document.querySelectorAll(main);
            select.forEach( e => {
                tl.from(e.querySelector(el), {
                    scale: 0.9,
                    y: '5rem',
                    scrollTrigger: {
                        trigger: e.querySelector(el),
                        end: 'top 50%',
                        scrub: true
                    }
                })
            })
        }
    )
}
